/* GENERATED FILE */
import type { ReactElement } from "react";
import { Fragment } from "react";
import type { IconVariant } from "../lib";

export default new Map<IconVariant, ReactElement>([
	[
		"duocolor",
		<Fragment key={"duocolor"}>
			<path
				opacity="0.4"
				d="M7 3V10M7 22L3 18M7 22L11 18M7 22V14"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M16 14H21L16 22H21M16 10V7M16 7V4.5C16 3.11929 17.1193 2 18.5 2C19.8807 2 21 3.11929 21 4.5V7M16 7H21M21 7V10"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"duotone",
		<Fragment key={"duotone"}>
			<g opacity="0.12">
				<path d="M16 14H21V22H16V14Z" fill="currentColor" />
				<path
					d="M16 10H21V4.5C21 3.11929 19.8807 2 18.5 2C17.1193 2 16 3.11929 16 4.5V10Z"
					fill="currentColor"
				/>
			</g>
			<path
				d="M7 22L3 18M7 22L11 18M7 22V14M7 3V10M16 14H21L16 22H21M16 10V7M16 7V4.5C16 3.11929 17.1193 2 18.5 2C19.8807 2 21 3.11929 21 4.5V7M16 7H21M21 7V10"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"filled",
		<Fragment key={"filled"}>
			<path
				d="M7 22L3 18M7 22L11 18M7 22V14M7 3V10M16 14H21L16 22H21M16 10V7M16 7V4.5C16 3.11929 17.1193 2 18.5 2C19.8807 2 21 3.11929 21 4.5V7M16 7H21M21 7V10"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"gestalt",
		<Fragment key={"gestalt"}>
			<path
				d="M11 18L7 22V14M7 3V10M4.5 19.5L3 18M16 14H21L16 22H21M16 10V7M16 7V4.5C16 3.11929 17.1193 2 18.5 2C19.8807 2 21 3.11929 21 4.5V7M16 7H21M21 7V10"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"line",
		<Fragment key={"line"}>
			<path
				d="M7 22L3 18M7 22L11 18M7 22V14M7 3V10M16 14H21L16 22H21M16 10V7M16 7V4.5C16 3.11929 17.1193 2 18.5 2C19.8807 2 21 3.11929 21 4.5V7M16 7H21M21 7V10"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"mono",
		<Fragment key={"mono"}>
			<path
				d="M7 22L3 18M7 22L11 18M7 22V14M7 3V10M16 14H21L16 22H21M16 10V7M16 7V4.5C16 3.11929 17.1193 2 18.5 2C19.8807 2 21 3.11929 21 4.5V7M16 7H21M21 7V10"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
]);
